



































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { GroupModel, GroupsApi, UserModel } from "../../../apis";
import ConfirmDialog from "../common/ConfirmDialog.vue";
@Component({
  components: { ConfirmDialog },
})
export default class ViewUserDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  keyword = "";
  @Prop({ default: [] }) users: UserModel[];
  @Prop() group: GroupModel;
  usersFiltered: UserModel[] = [];
  seletectedUser: UserModel | null = null;
  showConfirmDialog = false;
  confirmContent = "";

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  onSearch() {
    if (!this.keyword) {
      this.usersFiltered = [...this.users];
    } else {
      // this.lodash.debounce(function() {
      setTimeout(() => {
        this.usersFiltered = this.lodash.filter(
          this.users,
          (item) =>
            (item.email && item.email.toLowerCase().includes(this.keyword)) ||
            (item.fullName &&
              item.fullName.toLowerCase().includes(this.keyword))
        );
      }, 300);

      // }, 100);
    }
  }

  onShowRemoveUserDialog(item: UserModel) {
    this.seletectedUser = item;
    this.confirmContent = this.lodash.template(
      `${this.$t("dialog.removeUser.content")}`
    )({ user: this.seletectedUser.email });
    this.showConfirmDialog = true;
  }

  async onOk() {
    if (!this.seletectedUser) {
      return;
    }
    await new GroupsApi().removeUserInGroup({
      id: this.group.id,
      userId: this.seletectedUser.id,
    });
    this.onSave();
  }

  onSave() {
    this.$emit("onSave", "saved");
  }

  onClose() {
    this.$emit("onClose", "closed");
  }

  @Watch("show")
  onShowChanged(value: string, oldValue: string) {
    if (!value) this.onClose();
  }

  @Watch("users")
  onUsersChanged(value: string, oldValue: string) {
    this.usersFiltered = [...this.users];
  }

  getColor(status: string) {
    let color = "#00B162";
    switch (status) {
      case "NEW":
        color = "#FFB83D";
        break;
      case "INVITED":
        color = "#000000";
        break;
      case "APPROVED":
        color = "#FFB83D";
        break;
      case "INACTIVE":
        color = "#8A8A8A";
        break;
      default:
        break;
    }
    return color;
  }

  get me() {
    return this.$store.getters.user as UserModel;
  }
}
